module.exports = __webpack_public_path__ + "static/media/ship-bg-mobile-mystar.952e0a79.jpg";